import React from "react";
import { useForm } from "react-hook-form";
import { userAPI } from "../Redux/services/UserService";
import { useNavigate } from "react-router-dom";

interface CreateUserForm {
    login: string;
    password: string;
    full_name: string;
    role: string;
}

const CreateUser: React.FC = () => {
    const { register, handleSubmit, formState: { errors }, reset } = useForm<CreateUserForm>();
    const [createUser] = userAPI.useCreateUserMutation(); // ⚙️ предположим, что есть эндпоинт создания пользователя
    const navigate = useNavigate();

    const onSubmit = async (data: CreateUserForm) => {
        const date = new Date()
        const formattedDate = date.toISOString().slice(0, 19).replace('T', ' ');

        try {
            await createUser({
                login: data.login,
                full_name: data.full_name,
                role: data.role,
                password: data.password,
                is_active:true,
                date_online: formattedDate

            });
            reset();
            navigate("/admin"); // переход назад к списку пользователей
        } catch (err) {
            console.error("Помилка при створенні користувача", err);
        }
    };

    return (
        <div className="flex justify-center items-center min-h-[70vh]">
            <div className="bg-white shadow-lg rounded-xl p-8 w-full max-w-md border border-gray-200">
                <h2 className="text-2xl font-semibold mb-6 text-center text-gray-800">
                    Створення користувача
                </h2>

                <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
                    {/* Повне ім’я */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Повне ім’я
                        </label>
                        <input
                            type="text"
                            {...register("full_name", { required: "Вкажіть повне ім’я" })}
                            className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                                errors.full_name ? "border-red-500 focus:ring-red-400" : "border-gray-300 focus:ring-blue-400"
                            }`}
                            placeholder="Введіть повне ім’я"
                        />
                        {errors.full_name && (
                            <p className="text-red-500 text-sm mt-1">{errors.full_name.message}</p>
                        )}
                    </div>

                    {/* Логін */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Логін
                        </label>
                        <input
                            type="text"
                            {...register("login", { required: "Вкажіть логін" })}
                            className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                                errors.login ? "border-red-500 focus:ring-red-400" : "border-gray-300 focus:ring-blue-400"
                            }`}
                            placeholder="Введіть логін"
                        />
                        {errors.login && (
                            <p className="text-red-500 text-sm mt-1">{errors.login.message}</p>
                        )}
                    </div>

                    {/* Пароль */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Пароль
                        </label>
                        <input
                            type="password"
                            {...register("password", {
                                required: "Вкажіть пароль",
                                minLength: { value: 6, message: "Мінімум 6 символів" },
                            })}
                            className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                                errors.password ? "border-red-500 focus:ring-red-400" : "border-gray-300 focus:ring-blue-400"
                            }`}
                            placeholder="Введіть пароль"
                        />
                        {errors.password && (
                            <p className="text-red-500 text-sm mt-1">{errors.password.message}</p>
                        )}
                    </div>

                    {/* Роль */}

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Роль
                        </label>
                        <select
                            {...register("role", { required: "Виберіть роль" })}
                            className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                                errors.role ? "border-red-500 focus:ring-red-400" : "border-gray-300 focus:ring-blue-400"
                            }`}
                        >
                            <option value="">Оберіть роль</option>
                            <option value="admin">Адмін</option>
                            <option value="user">Користувач</option>
                        </select>
                        {errors.role && (
                            <p className="text-red-500 text-sm mt-1">{errors.role.message}</p>
                        )}
                    </div>
                    {/* Кнопки */}
                    <div className="flex justify-between mt-6">
                        <button
                            type="button"
                            onClick={() => navigate(-1)}
                            className="px-4 py-2 bg-gray-400 text-white rounded-md hover:bg-gray-500 transition"
                        >
                            Назад
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
                        >
                            Створити
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateUser;
